import data_control from "../../../../engines/libs/data_control";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import NormalGameManager from "../../manager/NormalGameManager";
import ShipData from "./ShipData";

export default class ShipDataManage {

    shipData = new ShipData();
 
    loadLocationData() {
        this.shipData.loadLocalData();
    }

    saveAllLocationData() {
        this.shipData.saveLocalData();
    }

    /**
     * 每天数据处理
     */
    dayDataDispose() {
        this.refreshShipData();
    }

    refreshShipData(bForce: boolean = false) {
        let curDay = NormalGameManager._instance.getCurrentDay();
        if (!bForce && curDay <= this.shipData.lastRefreshTime) {
            return;
        }
        this.shipData.lastRefreshTime = curDay;

        let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.SHIP);
        if (csvInfos == null) {
            console.error("SHIP csvInfos == null");
            return;
        }
        let title = csvInfos.title;
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            let data = this.shipData.lists.get(i);
            if (!data) {
                continue;
            }
            let info = csvInfos[i];
            let min = Number(info[title.change_trend_min]);
            let repertory = Number(info[title.repertory]);
            let max = Number(info[title.change_trend_max]);
            let recover_sotre = Number(info[title.recover_sotre]);
            let randomV = data_control.randomNumInt(min, max);
            // let price = Number(info[title.price]);
            data.price = Math.floor(Math.max(1, data.price * (1 + randomV / 100)));
            if (data.store < repertory) {
                let cStore = data.store + recover_sotre;
                data.store = Math.min(repertory, cStore);
            }
        }
        this.shipData.saveLocalData();
    }
}
